<template>
  <div>
    <v-toolbar
      color="theme_primary"
      dark
      extension-height="36"
      height="36"
      flat
      app
    >
      <v-toolbar-side-icon @click="drawerToggle()">
        <v-icon>{{ drawerIcon() }}</v-icon>
      </v-toolbar-side-icon>
      <v-layout align-center>
        <v-icon size="12" left>file_copy</v-icon>
        <v-breadcrumbs
          :items="[
            {
              exact: false,
              text: 'Contracts',
              disabled: true,
              to: '/contracts',
            },
          ]"
          dark
        >
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
        </v-breadcrumbs>
        <v-spacer></v-spacer>
        <headerProfile />
      </v-layout>

      <template v-slot:extension>
        <v-tabs
          v-model="tab"
          left
          color="transparent"
          slider-color="primary"
          height="36"
        >
          <v-tab
            active-class="active-tab primary--text"
            href="#validatedContracts"
            v-if="currentUserCan('see', 'validated_contracts')"
          >
            <v-icon small>mdi-file-check</v-icon>
            <span class="font-weight-bold pl-2">Validated</span>
          </v-tab>
          <v-tab
            active-class="active-tab primary--text"
            href="#pendingContracts"
            v-if="currentUserCan('see', 'pending_contracts')"
          >
            <v-icon small>mdi-file-clock</v-icon>
            <span class="font-weight-bold pl-2">Pending</span>
          </v-tab>
          <v-tab
            active-class="active-tab primary--text"
            href="#archivedContracts"
            v-if="currentUserCan('see', 'archived_contracts')"
          >
            <v-icon small>mdi-file-lock</v-icon>
            <span class="font-weight-bold">Archived</span>
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>

    <!--
          Test du bouton New dans le component contractStatusIndex.vue au lieu d'en haut a droite - Sam
          <v-layout justify-end>
          <v-btn class="primary" :to="{ name: 'newContract' }" v-if="currentUserCan('create','contract')">New</v-btn>
    </v-layout>-->

    <v-tabs-items v-model="tab">
      <v-tab-item
        value="validatedContracts"
        lazy
        v-if="currentUserCan('see', 'validated_contracts')"
      >
        <v-flex px-4 pt-2>
          <contractsStatusOrArchivedIndex status="validated" />
        </v-flex>
      </v-tab-item>
      <v-tab-item
        value="pendingContracts"
        lazy
        v-if="currentUserCan('see', 'pending_contracts')"
      >
        <v-flex px-4 pt-2>
          <contractsStatusOrArchivedIndex status="pending" />
        </v-flex>
      </v-tab-item>
      <v-tab-item
        value="archivedContracts"
        lazy
        v-if="currentUserCan('see', 'archived_contracts')"
      >
        <v-flex px-4 pt-2>
          <contractsStatusOrArchivedIndex v-bind:archived="true" />
        </v-flex>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import contractsStatusOrArchivedIndex from "../components/contracts/contractsStatusOrArchivedIndex";
import headerProfile from "../components/shared/headerProfile";
export default {
  components: { contractsStatusOrArchivedIndex, headerProfile },

  data() {
    return {
      tab: this.$route.query.tab ? this.$route.query.tab : "pendingContracts",
    };
  },
  watch: {
    "$route.query.tab": function () {
      this.tab = this.$route.query.tab
        ? this.$route.query.tab
        : "pendingContracts";
    },
  },
};
</script>
